import { getDraftReportComponentDatasetQueryStateKey } from '@/shared/components/modals/ResourceActionModals/EditReportComponentModal/helpers/hook';
import { useReportComponentStore } from '@/stores';
import { ReportComponent } from '@/types';

export const useEditingReportComponent = (fallbackComponent?: ReportComponent) => {
    const id = useReportComponentStore((state) => state.editingComponentId);

    const component = useReportComponentStore((state) => (id ? state.reportComponents.find((c) => c.id === id) : null));

    const draft = useReportComponentStore((state) => (id ? state.draftConfigurations[id] : null));
    const draftProperties = useReportComponentStore((state) => (id ? state.draftProperties[id] : null));

    const resolvedComponent = component ?? fallbackComponent;

    if (!resolvedComponent) {
        return null;
    }

    return {
        ...fallbackComponent,
        ...resolvedComponent,
        ...draftProperties,
        __datasetQueryStateKey: getDraftReportComponentDatasetQueryStateKey(resolvedComponent.id),
        configuration: draft ?? resolvedComponent.configuration ?? fallbackComponent?.configuration,
    };
};
